export default "__VITE_ASSET__BHdEdRDg__"